module.exports = __webpack_public_path__ + "static/media/4.eaf374d6.jpg";